import Card from 'components/Card'
import PropTypes from 'prop-types'
import React from 'react'
import Text from 'components/Text'

import './pickFeedbackQuestionModal.less'
import FeedbackModalCard from '../FeedbackModalCard'
import { useTranslation } from 'react-i18next'

const PickFeedbackQuestionModal = ({
  feedbackQuestionsForUser,
  onClose,
  onQuestionClicked,
}) => {
  const { t } = useTranslation()

  const renderQuestion = feedbackQuestion => {
    const onClick = () => onQuestionClicked(feedbackQuestion)

    return (
      <Card isHoverable key={feedbackQuestion.id} onClick={onClick}>
        <Text>{feedbackQuestion.question}</Text>
      </Card>
    )
  }

  return (
    <FeedbackModalCard
      onClose={onClose}
      title={t('portCall.feedback.pickAQuestion')}
    >
      <div className="pick-feedback-question__container">
        {feedbackQuestionsForUser.map(feedbackQuestion =>
          renderQuestion(feedbackQuestion)
        )}
      </div>
    </FeedbackModalCard>
  )
}

PickFeedbackQuestionModal.propTypes = {
  feedbackQuestionsForUser: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  onQuestionClicked: PropTypes.func.isRequired,
}

export default PickFeedbackQuestionModal
